import { IComponentConfiguration } from '@kurtosys/ksys-app-components/dist/models/IComponentConfiguration';
import ApplicationEmbed from '@kurtosys/ksys-app-components/dist/components/base/ApplicationEmbed';
import Card from '@kurtosys/ksys-app-components/dist/components/base/Card';
import Text from '@kurtosys/ksys-app-components/dist/components/base/Text';
import AsOfDate from '@kurtosys/ksys-app-components/dist/components/base/AsOfDate';
import Heading from '@kurtosys/ksys-app-components/dist/components/base/Heading';
import Image from '@kurtosys/ksys-app-components/dist/components/base/Image';
import Label from '@kurtosys/ksys-app-components/dist/components/base/Label';
import Link from '@kurtosys/ksys-app-components/dist/components/base/Link';
import Disclaimers from '@kurtosys/ksys-app-components/dist/components/overview/Disclaimers';

export const LIBRARY_COMPONENTS_CONFIGURATION: IComponentConfiguration = {
	base: {
		grid: {
			components: {
				'base.applicationEmbed': {
					key: 'base.applicationEmbed',
					component: ApplicationEmbed,
				},
				'base.card': {
					key: 'base.card',
					component: Card,
				},
				'base.text': {
					key: 'base.text',
					component: Text,
				},
				'base.asOfDate': {
					key: 'base.asOfDate',
					component: AsOfDate,
				},
				'base.heading': {
					key: 'base.heading',
					component: Heading,
				},
				'base.image': {
					key: 'base.image',
					component: Image,
				},
				'base.label': {
					key: 'base.label',
					component: Label,
				},
				'base.link': {
					key: 'base.link',
					component: Link,
				},
				'overview.disclaimers': {
					key: 'overview.disclaimers',
					component: Disclaimers,
				},
			},
		},
	},
};